
import { ElectronFunctions } from "@/utils/electron/electron";
import { IElectronPrinter } from "@/utils/electron/electron-printer";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			defaultPrinterId: "",
			copyCount: 0
		};
	},
	props: {
		printers: {
			type: Array as ()=>IElectronPrinter[],
			required: true
		},
		layoutId: {
			type: Number,
			required: true
		}
	},
	computed: {
		printerItems():ISelectItem<string>[]{
			let result:ISelectItem<string>[] = [
				{
					text: this.$ct("common.none"),
					value: ""
				}
			];

			result.push(...this.printers.map(p=>{
				return {
					text: p.name,
					value: p.deviceId
				};
			}));

			return result;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			ElectronFunctions.setDefaultPrinterIdForSaleLayout(this.layoutId, this.defaultPrinterId);
			if (this.defaultPrinterId == ""){
				ElectronFunctions.setCopyCountForSaleLayout(this.layoutId, 0);
			}else{
				ElectronFunctions.setCopyCountForSaleLayout(this.layoutId, this.copyCount);
			}
			this.close();
		}
	},
	mounted(){
		this.defaultPrinterId = ElectronFunctions.getDefaultPrinterIdForSaleLayout(this.layoutId);
		this.copyCount = ElectronFunctions.getCopyCountForSaleLayout(this.layoutId);
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
